<style>
  .my-step {
    position: relative;
    top: 0;
    left: 0;
    color: #666;
  }

  .active .my-step {
    color: #000;
  }
  .van-step--vertical.active .van-step__circle {
    position: absolute;
    z-index: 2;
    top: 12px;
    left: -22px;
    line-height: 1;
    width: 0;
    height: 0;
    font-size: 12px;
    font: normal normal normal 14px/1 vant-icon;
  }
  .van-step--vertical.active .van-step__circle::before {
      content: "\F012";
      color: #F7A668;
  }

  .my-step__msg {
    font-size: .24rem;
    line-height: 1.5;
  }

  .my-step__btn {
    position: absolute;
    top: 0;
    /* top: 50%; */
    right: 0;
    /* margin-top: -.28rem; */
  }

  .my-step__btn a:visited,
  .my-step__btn a {
    color: #9B9B9B;
    display: inline-block;
    border: 1px solid #9B9B9B;
    border-radius: 0.06rem;
    padding: 0 0.2rem;
    height: 0.56rem;
    line-height: 0.56rem;
    box-sizing: border-box;
    font-size: .24rem;
  }

  .my-step__btn a.active:visited,
  .my-step__btn a.active {
    color: #B62929;
    border-color: #B62929;
  }

</style>

<template>

  <div class="mod my-steps">
    <div class="mod__hd">
      <img src="../../../../assets/img/base/title-my-detail.png" alt="我的进展" />
    </div>
    <div class="mod_bd">
      <div v-if="preBegin > 0" class="my-steps">
        <van-steps direction="vertical" :active="-1" active-color="#F7A668">
          <van-step class="active">
            <my-step-sign />
          </van-step>

          <van-step :class="{active: isAfter(preBegin)}">
            <my-step-pre />
          </van-step>

          <van-step :class="{active: isAfter(preRes)}">
            <my-step-pre-res />
          </van-step>

          <van-step :class="{active: isAfter(finalBegin)}">
            <my-step-final />
          </van-step>

          <van-step :class="{active: isAfter(finalRes)}">
            <my-step-final-res />
          </van-step>

          <van-step :class="{active: isAfter(awardTime)}">
            <my-step-award />
          </van-step>
        </van-steps>
      </div>
      <txt-loading v-else />
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  import MyStepSign from './sign'
  import MyStepPre from './pre'
  import MyStepPreRes from './pre-res'
  import MyStepFinal from './final'
  import MyStepFinalRes from './final-res'
  import MyStepAward from './award'

  export default {
    name: 'my-steps',
    components: {
      [MyStepSign.name]: MyStepSign,
      [MyStepPre.name]: MyStepPre,
      [MyStepPreRes.name]: MyStepPreRes,
      [MyStepFinal.name]: MyStepFinal,
      [MyStepFinalRes.name]: MyStepFinalRes,
      [MyStepAward.name]: MyStepAward
    },
    data() {
      return {
        active: 0
      }
    },
    computed: {
      ...mapGetters(['nowTime', 'isBefore', 'isAfter', 'signBegin', 'preBegin', 'preEnd', 'preRes', 'finalBegin', 'finalEnd',
        'finalRes',
        'awardTime', 'finishCupNum', 'allCupNum',
        'isAdvance', 'isFinishFinal',
        'preRank', 'preScore', 'finalRank', 'finalScore', 'maxAvgScore'
      ]),
      curStep() {
        const {
          nowTime,
          preBegin,
          // preEnd,
          preRes,
          finalBegin,
          // finalEnd,
          finalRes,
          awardTime
        } = this
        const all = [preBegin, preRes, finalBegin, finalRes, awardTime]
        const length = all.length
        let index = 0
        for (; index < length; index++) {
          if (nowTime < all[index]) {
            break
          }
        }
        return index
      }
    },
    methods: {
      ...mapActions(['loadMyDetail', 'goTrialDK', 'goPrePlay']),
      ...mapActions('reality', ['loadGames'])
    },
    // watch: {
    //   curStep(i) {
    //     this.active = i
    //   }
    // },
    async created() {
      await this.loadMyDetail()
      // this.active = this.curStep
      // console.log(JSON.stringify(games));
    }
  };

</script>
